// Debug mode removed for performance

try {
  window.GiftLogger = {
    logs: [],
    debugMode: window.themeSettings?.debug_mode || false,

    log(category, message, data = null) {
      const timestamp = new Date().toISOString();
      const entry = {
        timestamp,
        category,
        message,
        data
      };
      
      this.logs.push(entry);
      
      // Only log to console if debug mode is enabled
      if (!this.debugMode) return;

      if (category === 'START') {
        console.group(`🎁 ${message}`);
      } else if (category === 'END') {
        console.log(`✅ ${message}`, data || '');
        console.groupEnd();
      } else if (category === 'COORDINATOR') {
        console.log(`🔄 ${message}`, data || '');
      } else if (category === 'QUEUE') {
        console.log(`📋 ${message}`, data || '');
      } else if (category === 'GIFT') {
        console.log(`🎀 ${message}`, data || '');
      } else if (category === 'ERROR') {
        console.error(`❌ ${message}`, data || '');
      } else {
        console.log(`${category}: ${message}`, data || '');
      }
    },

    // Enhanced state logging for coordinator
    state(label, cart, queueState = null) {
      const stateData = {
        items: cart.items.map(item => ({
          id: item.product_id,
          variant: item.variant_id,
          quantity: item.quantity,
          properties: item.properties
        })),
        total: cart.total_price,
        queue: queueState
      };
      
      this.log('STATE', label, stateData);
    },

    // New method for logging coordinator events
    coordinator(action, details) {
      this.log('COORDINATOR', action, details);
    },

    // New method for logging queue events
    queue(action, request) {
      this.log('QUEUE', action, request);
    },

    // New method for logging gift processing
    gift(action, giftDetails) {
      this.log('GIFT', action, giftDetails);
    },

    // Enhanced methods to help retrieve logs
    printLogs(filter = null) {
      console.group('🎁 Gift System Activity Log');
      this.logs
        .filter(entry => !filter || entry.category === filter)
        .forEach(entry => {
          console.log(`[${entry.timestamp}] ${entry.category}: ${entry.message}`, entry.data || '');
        });
      console.groupEnd();
    },

    getLogs(filter = null) {
      const filteredLogs = filter 
        ? this.logs.filter(entry => entry.category === filter)
        : this.logs;
      return JSON.stringify(filteredLogs, null, 2);
    },

    clearLogs() {
      this.logs = [];
      console.clear();
    },

    downloadLogs(filter = null) {
      const logs = this.getLogs(filter);
      const blob = new Blob([logs], {type: 'application/json'});
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `gift-system-logs-${new Date().toISOString()}.json`;
      a.click();
      URL.revokeObjectURL(url);
    }
  };
} catch (error) {
  console.error('Failed to initialize GiftLogger:', error);
} 